import isEmpty from 'lodash/isEmpty'
type CustomRuleType = { getFieldValue: (arg: string) => string }

const required = { required: true, message: 'This is a required field' }
const requiredRule = [required]

export { requiredRule }
